import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardApplicationModel, DashboardPartnerModel } from '../shared/models/dashboard.model';
import { DashboardService } from './dashboard.service';

@Component({
  selector: 'ppb-dashboard',
  templateUrl: './ppb-dashboard.component.html',
  styleUrls: ['./ppb-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbDashboardComponent implements OnInit {

  selectedPartner: DashboardPartnerModel;
  partnerByCode: { [partnerCode: string]: DashboardPartnerModel };
  partnersDashboards: DashboardPartnerModel[];
  tooltipText = $localize`:@@shared.app_unavailable:Aplikacja nie jest jeszcze dostępna`

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    const partnersArray: DashboardPartnerModel[] = this.route.snapshot.data.partnersArray;
    this.setup(partnersArray);
  }

  exchangeSecretForUuid(app: DashboardApplicationModel): void {
    let url = app.url;
    const isDisabled = this.isApplicationDisabled(app);
    const addLanguage = ['preu', 'arso'].indexOf(app.name) !== -1;
    if (!isDisabled) {
      this.dashboardService.exchangeSecretForUuid(this.selectedPartner)
        .subscribe(
          response => {
            const isLocalDev = /localhost/.test(window.origin);
            if (isLocalDev) {
              url = url.replace('https://woze-dev.inno.pse.pl', 'http://localhost:4200')
            }
            this.dashboardService.redirect(url, response.uuid, addLanguage);
          });
    }
  }

  onChange(partnerCode: any): void {
    this.selectedPartner = this.partnerByCode[partnerCode];
    this.cd.markForCheck();
  }

  isApplicationSectionActive(): boolean {
    return this.selectedPartner !== undefined && this.selectedPartner.boardDtoList && this.selectedPartner.boardDtoList.length > 0;
  }

  isPartnerSectionActive(): boolean {
    return this.partnersDashboards !== undefined && this.partnersDashboards.length > 0;
  }

  isApplicationDisabled(app: DashboardApplicationModel): boolean {
    return app.status !== 'AVAILABLE';
  }

  getId(app: DashboardApplicationModel): string {
    return app.name;
  }

  isSelected(item: DashboardPartnerModel): boolean {
    return this.selectedPartner && item.partnerCode === this.selectedPartner.partnerCode;
  }

  private setup(partnersArray: DashboardPartnerModel[]): void {
    this.partnerByCode = {};
    partnersArray.forEach((dashboardPartner: DashboardPartnerModel) => {
      this.partnerByCode[dashboardPartner.partnerCode] = dashboardPartner;
    });
    this.selectedPartner = partnersArray[0];
    this.partnersDashboards = partnersArray;
    this.cd.markForCheck();
  }
}
